<template>
  <layout-main-inner
    v-loading="loading"
    title="标签管理">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">生产标签</el-button>
      <el-button
        type="primary"
        @click="handleCurrentChange(1)">刷新</el-button>
    </div>
    <layout-card-wrap>
      <el-table
        border
        :data="list">
        <el-table-column
          label="开始标签序号"
          min-width="180"
          prop="beginTagNo">
          <template slot-scope="{ row }">{{ row.beginTagNo | tagCount() }}-{{ row.endTagNo | tagCount() }}</template>
        </el-table-column>
        <el-table-column
          label="生产数量"
          width="130"
          prop="tagCount"></el-table-column>
        <el-table-column
          label="未分配数量"
          width="130"
          prop="notAssignTagCount"></el-table-column>
        <el-table-column
          label="未使用数量"
          width="130"
          :formatter="row => row.tagCount - row.usedTagCount - row.scrappedTagCount"
          prop="usedTagCount"></el-table-column>
        <el-table-column
          label="报废数量"
          width="100"
          prop="scrappedTagCount"></el-table-column>
        <el-table-column
          label="生产备注"
          min-width="160"
          prop="remarks"></el-table-column>
        <el-table-column
          label="生产时间"
          width="150">
          <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="110">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="allocationLabel(row)">分配</el-button>
            <!-- <el-button
              type="text"
              @click="cancelProductionLabel(row)">取消生产</el-button> -->
            <el-dropdown>
              <el-button
                type="text"
                style="margin-left: 10px">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="cancelProductionLabel(row)">取消生产</el-dropdown-item>
                <el-dropdown-item @click.native="scrappedLabel(row)">报废处理</el-dropdown-item>
                <el-dropdown-item @click.native="viewScrappedLabels(row)">查看已报废</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>

    <label-production-modal
      ref="production"
      @fetch="fetchList" />

    <label-allocation-modal
      ref="allocation"
      @fetch="fetchList" />

    <label-scrap-modal
      ref="scrap"
      @fetch="fetchList" />
    <label-scrapped-modal
      ref="scrapped" />
  </layout-main-inner>
</template>
<script>
import AppraiseLable from '../../../service/appraiseLable'
import LabelAllocationModal from './label-production/label-allocation-modal.vue'
import LabelProductionModal from './label-production/label-production-modal.vue'
import LabelScrapModal from './label-production/label-scrap-modal.vue'
import LabelScrappedModal from './label-production/label-scrapped-modal.vue'
export default {
  name: 'LabelProduction',
  components: { LabelProductionModal, LabelAllocationModal, LabelScrapModal, LabelScrappedModal },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10 }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    viewScrappedLabels(row) {
      const { tagSegId } = row
      this.$refs.scrapped.fetch({ tagSegId })
    },
    scrappedLabel(row) {
      const { tagSegId, beginTagNo: min, endTagNo: max } = row
      this.$refs.scrap.fetch({ tagSegId }, { min, max })
    },
    additem() {
      this.$refs.production.init()
    },
    allocationLabel(row) {
      const { beginTagNo: min, endTagNo: max, notAssignTagCount: maxAssignCount, tagSegId } = row
      this.$refs.allocation.init({ min, max, maxAssignCount }, { tagSegId })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    cancelProductionLabel(row) {
      this.$confirm('是否取消生产?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          AppraiseLable.deletetagsegment({ tagSegId: row.tagSegId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('取消成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    fetchList() {
      this.loading = true
      AppraiseLable.gettagsegments({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
